import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVoucher } from "src/models/Prices/Voucher.models";

interface VoucherState {
  vouchers: IVoucher[];
  voucherToEdit: IVoucher | null;
}

const initialState: VoucherState = {
  vouchers: [],
  voucherToEdit: null,
};

const VoucherSlice = createSlice({
  name: "Voucher",
  initialState,
  reducers: {
    setVoucherList: (state, action: PayloadAction<IVoucher[]>) => {
      state.vouchers = action.payload;
    },
    setVoucherToEdit: (state, action: PayloadAction<IVoucher | null>) => {
      state.voucherToEdit = action.payload;
    },
    concatListVoucher: (
      state: VoucherState,
      action: PayloadAction<IVoucher[]>
    ) => {
      state.vouchers = [...state.vouchers.concat(action.payload)];
    },
    addVoucher: (state, action: PayloadAction<IVoucher>) => {
      state.vouchers.push(action.payload);
    },
    updateVoucher: (state, action: PayloadAction<IVoucher>) => {
      let itemIndex = state.vouchers.findIndex(
        item => item.voucherId === action.payload.voucherId
      );
      if (itemIndex !== -1) state.vouchers[itemIndex] = action.payload;
    },
    deleteVoucher: (state, action: PayloadAction<number>) => {
      const newArray = state.vouchers.filter(
        item => item.voucherId !== action.payload
      );
      state.vouchers = newArray;
    },
    setURLToAVoucherToEdit: (
      state,
      action: PayloadAction<string | null>
  ) => {
      if (state.voucherToEdit)
        state.voucherToEdit.url = action.payload;
  },
  },
});

export const {
  setVoucherList,
  concatListVoucher,
  setVoucherToEdit,
  setURLToAVoucherToEdit,
  addVoucher,
  updateVoucher,
  deleteVoucher,
} = VoucherSlice.actions;

export default VoucherSlice.reducer;
